import { Directive, ElementRef, HostBinding, HostListener } from '@angular/core';
import { PercentPipe } from './percent.pipe';

@Directive({
  standalone: false,
  selector: 'input[appPercentFormatter]'
})
export class PercentFormatterDirective {

  private el: HTMLInputElement;
  private pipe: PercentPipe;

  @HostBinding('value') value: string;

  constructor(private elementRef: ElementRef) {
    this.el = this.elementRef.nativeElement;
    this.pipe = new PercentPipe();
  }

  @HostListener('focus', ['$event.target.value'])
  onFocus(value: string) {
    this.el.value = this.pipe.parse(value).toString();
  }

  @HostListener('blur', ['$event.target.value'])
  onBlur(value: string) {
    this.el.value = this.pipe.transform(value);
  }
}
